import { useState, useEffect } from "react";
import { Card, PageHeader, Input, Select, Btn } from "../../components/shared/UIComponents";
import { SocietyAPI } from "../../services/api";

export default function ManageSociety({ adminUser }) {
  const [form, setForm] = useState({ societyName:'', registrationNumber:'', phone:'', email:'', gstNumber:'', panNumber:'', state:'Maharashtra', city:'', address:'', pinCode:'' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving]   = useState(false);
  const [msg, setMsg]         = useState(null);
  const [societyId, setSocietyId] = useState(null);

  useEffect(() => {
    SocietyAPI.getMy()
      .then(data => {
        const s = Array.isArray(data) ? data[0] : data;
        if (s) {
          setSocietyId(s.id);
          setForm({
            societyName: s.societyName || s.name || '',
            registrationNumber: s.registrationNumber || '',
            phone: s.phone || '',
            email: s.email || '',
            gstNumber: s.gstNumber || '',
            panNumber: s.panNumber || '',
            state: s.state || 'Maharashtra',
            city: s.city || '',
            address: s.address || '',
            pinCode: s.pinCode || '',
          });
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const f = (key) => ({ value: form[key]||'', onChange: e => setForm(p=>({...p,[key]:e.target.value})) });

  const handleSave = async () => {
    if (!societyId) { setMsg({ type:'error', text:'No society found. Please register a society first.' }); return; }
    setSaving(true); setMsg(null);
    try {
      await SocietyAPI.update(societyId, form);
      setMsg({ type:'success', text:'Society details updated successfully!' });
    } catch(e) { setMsg({ type:'error', text: e.message }); }
    finally { setSaving(false); }
  };

  if (loading) return <Card><div style={{ padding:40, textAlign:'center', color:'#78909c' }}>Loading society details…</div></Card>;

  return (
    <Card>
      <PageHeader title="Manage Society" />
      <div style={{ padding: 24 }}>
        {msg && <div style={{ padding:"10px 14px", borderRadius:8, marginBottom:16, fontSize:13, background: msg.type==='success'?'#e8f5e9':'#fce8e6', color: msg.type==='success'?'#2e7d32':'#c62828' }}>{msg.text}</div>}
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:16 }}>
          <Input label="Society Name" placeholder="Society Name" {...f('societyName')} />
          <Input label="Registration Number" placeholder="Reg No" {...f('registrationNumber')} />
          <Input label="Mobile No" placeholder="Mobile" {...f('phone')} />
          <Input label="Email" placeholder="Email" {...f('email')} />
          <Input label="GST Number" placeholder="GST No" {...f('gstNumber')} />
          <Input label="PAN Number" placeholder="PAN No" {...f('panNumber')} />
          <Select label="State" options={["Maharashtra","Delhi","Gujarat","Karnataka","Tamil Nadu","Rajasthan"]} {...f('state')} />
          <Input label="City" placeholder="City" {...f('city')} />
          <Input label="Pin Code" placeholder="Pin Code" {...f('pinCode')} />
          <Input label="Address" placeholder="Address" style={{ gridColumn:"span 3" }} {...f('address')} />
        </div>
        <div style={{ marginTop:20, display:"flex", gap:10 }}>
          <Btn onClick={handleSave} disabled={saving}>{saving ? 'Saving…' : 'Save Changes'}</Btn>
        </div>
      </div>
    </Card>
  );
}
